
"use client";

import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { cn } from "@/lib/utils";

const TooltipProvider = TooltipPrimitive.Provider;
const Tooltip = TooltipPrimitive.Root;
const TooltipTrigger = TooltipPrimitive.Trigger;

// Radix does NOT portal Content implicitly — `Tooltip.Portal` is a separate part.
// Rendered inline, the tooltip is clipped by any ancestor with overflow:hidden,
// and z-index cannot recover it because clipping happens first. The renewal-risk
// badge on AccountFinal sat inside the account header card and lost its top three
// lines to exactly this. Collision detection does not help: it measures the
// viewport, not the clipping ancestor, so it sees room above and places it there.
const TooltipContent = React.forwardRef(
  ({ className, sideOffset = 8, collisionPadding = 12, ...props }, ref) => (
    <TooltipPrimitive.Portal>
      <TooltipPrimitive.Content
        ref={ref}
        sideOffset={sideOffset}
        // Keeps the tooltip off the viewport edge and lets Radix flip sides
        // rather than render a tooltip half off-screen.
        collisionPadding={collisionPadding}
        className={cn(
          "z-[10000] rounded-md px-3 py-2 text-xs shadow-md",
          "bg-[#0A1A2F] text-white border-0",
          "data-[state=open]:opacity-100 data-[state=closed]:opacity-0 transition-opacity duration-100",
          className
        )}
        {...props}
      />
    </TooltipPrimitive.Portal>
  )
);
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { TooltipProvider, Tooltip, TooltipTrigger, TooltipContent };
